import { render, staticRenderFns } from "./PaymentsListBlock.vue?vue&type=template&id=44bdf66e&scoped=true&"
import script from "./PaymentsListBlock.vue?vue&type=script&lang=js&"
export * from "./PaymentsListBlock.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsListBlock.vue?vue&type=style&index=0&id=44bdf66e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44bdf66e",
  null
  
)

export default component.exports